import React, { useState, useEffect, memo, useCallback } from "react";
import { Alert, Button, Space } from "antd";
import { ReloadOutlined, WifiOutlined } from "@ant-design/icons";

/**
 * 网络状态检测组件
 */
export const NetworkStatus = memo(() => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showAlert, setShowAlert] = useState(false);

  const handleRetry = useCallback(() => {
    window.location.reload();
  }, []);

  const handleCloseAlert = useCallback(() => {
    setShowAlert(false);
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowAlert(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowAlert(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOnline && showAlert) {
    return (
      <Alert
        message="网络连接已断开"
        description="请检查您的网络连接，然后重试。"
        type="error"
        showIcon
        icon={<WifiOutlined />}
        action={
          <Space>
            <Button
              size="small"
              onClick={handleRetry}
              icon={<ReloadOutlined />}
            >
              重试
            </Button>
            <Button size="small" onClick={handleCloseAlert}>
              关闭
            </Button>
          </Space>
        }
        style={{ marginBottom: 16 }}
      />
    );
  }

  return null;
});

NetworkStatus.displayName = "NetworkStatus";

export default NetworkStatus;
